<template>
  <v-dialog v-if="showGlobalMessage" v-model="dialogVisible" persistent max-width="600">
    <v-card>
      <v-card-title class="headline" v-if="messages.length > 0">{{ messages[messageIndex].title }} - {{
        messages[messageIndex].createdOn | formatDate }}</v-card-title>

      <v-card-text style="padding: 0px 18px 0px 18px;">
        <div v-if="messages.length > 0">
          {{ messages[messageIndex].content }}
        </div>
      </v-card-text>
      <v-card-actions style="padding: 0px 14px 0px 14px;">
        <v-checkbox v-model="messageReadCheckboxes[messageIndex]"
          label="I have read and understand this message"></v-checkbox>
        <v-btn v-if="!isLastMessage" :disabled="!messageReadCheckboxes[messageIndex]" @click="nextMessage" class="ml-auto">Next Message</v-btn>
        <v-btn stacked v-if="isLastMessage" :disabled="!allCheckboxesCompleted" @click="submitMessages" class="ml-auto">Accept Messages</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

export default {
  computed: {
    allCheckboxesCompleted () {
      // Check if all checkboxes are true
      return this.messageReadCheckboxes.every(checkbox => checkbox)
    },
    isLastMessage () {
      // Check if the current message is the last one in the collection
      return this.messageIndex === this.messages.length - 1
    }
  },
  filters: {
    formatDate (val) {
      return moment(val).format('DD/MM/YYYY HH:mm')
    }
  },
  props: {
    showDialog: Boolean,
    message: String
  },
  data () {
    return {
      url: this.$store.getters.url,
      user: this.$store.getters.user,
      company: this.$store.getters.company,
      dialogVisible: false,
      messages: [],
      messageIndex: 0,
      messageReadCheckboxes: [],
      showGlobalMessage: false
    }
  },
  watch: {
    showDialog: {
      handler (newVal) {
        this.dialogVisible = newVal
        if (newVal) {
          // Get the messages from the database
          this.getGlobalMessages()
        }
      },
      immediate: true
    }
  },
  methods: {
    closeDialog () {
      this.$emit('closeDialog')
    },
    getGlobalMessages () {
      axios.post(this.url + `/tanda-service/getGlobalMessage.ajax.php`, {
        company: this.company,
        empID: this.user.empID
      })
        .then(result => {
          if (result.data && Array.isArray(result.data) && result.data.length > 0) {
            this.showGlobalMessage = true
            this.messages = result.data.map(message => {
              return {
                id: message.id,
                content: message.Message_Content,
                createdOn: message.Created_On,
                title: message.Message_Title
              }
            })
            this.messageReadCheckboxes = Array(this.messages.length).fill(false)
          } else {
            this.showGlobalMessage = false
          }
        })
        .catch(error => {
          console.error(error)
        })
    },
    nextMessage () {
      if (this.messageIndex < this.messages.length - 1) {
        this.messageIndex++
      } else {
        this.closeDialog()
      }
    },
    submitMessages () {
      // Loop through messages and checkboxes to submit to the database
      for (let i = 0; i < this.messages.length; i++) {
        const message = this.messages[i]
        const checkbox = this.messageReadCheckboxes[i]

        if (checkbox === true) {
          this.markMessageAsSeen(message.id)
        }
      }

      // Close the dialog
      this.closeDialog()
    },
    markMessageAsSeen (messageID) {
      axios
        .post(
          this.url + `/tanda-service/markMessageAsSeen.ajax.php`, {
            empID: this.user.empID,
            company: this.company,
            globalMessageID: messageID
          }
        )
        .then((result) => {
        })
        .catch((error) => {
          console.error('Error marking message as seen:', error)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/GlobalMessage.vue